module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAYCAYAAAAh8HdUAAAAmUlEQVQ4jZ3UMQ7CMAyF4T8ZurPAabhFr8ClYGLnZEyduzwGUqlKE9uppch5wye9yUiaJN3LJvKSpAvw5j8zsOJMBhbgUfIHmCJIwHcE5rKHYN79wzBXOQRrFIIt5MIeMmGSZDgAEnAFXiXPEbTBG/D06rXqEkWHeh46AGC1UBNY9bqgh0zQQi6oUQjsURhsaAgA5w4LZ07YD2OriSWynTJDAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner_jt_r.png
// module id = AhQh
// module chunks = 0